import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/** Set on a request's HttpContext to keep the global spinner hidden for that call. */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

/**
 * HTTP Interceptor per gestire automaticamente lo spinner di caricamento globale
 * - Mostra lo spinner quando parte una richiesta HTTP
 * - Nasconde lo spinner quando la richiesta completa (successo o errore)
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Silent background auth calls (startup session restore, logout) must not
  // trigger the global spinner — they are invisible housekeeping operations.
  const isSilentAuthCall =
    req.url.includes('/api/auth/silent-refresh') ||
    req.url.includes('/api/auth/logout');

  if (isSilentAuthCall || req.context.get(SKIP_LOADER)) {
    return next(req);
  }

  // Mostra lo spinner all'inizio della richiesta
  loadingService.show();

  // Processa la richiesta e nascondi lo spinner al completamento
  return next(req).pipe(
    finalize(() => {
      // finalize viene eseguito sia su successo che su errore
      loadingService.hide();
    })
  );
};
